/**
 * The visible canvas IS the working area now, so the dashed-outline
 * overlay is only useful when the coach wants a green border around
 * a custom grid. For non-full views, draw a subtle dashed border
 * around the working rect so the bounds read as deliberate.
 */
import { pitchViewBox, visibleRegion, type PitchView, type CustomPitch } from './pitchArea';
import type { PitchSpec } from './pitchSpecs';

interface PitchAreaOverlayProps {
  view: PitchView;
  custom?: CustomPitch | null;
  spec: PitchSpec;
}

export function PitchAreaOverlay({ view, custom, spec }: PitchAreaOverlayProps): React.JSX.Element | null {
  if (view === 'full') return null;
  const region = visibleRegion(spec, view, custom);
  const rect = {
    cx: region.cx - region.length / 2,
    cy: region.cy - region.width / 2,
    w: region.length,
    h: region.width,
  };
  const SW = Math.min(0.4, region.width * 0.012);
  return (
    <svg
      viewBox={pitchViewBox(spec, view, custom)}
      preserveAspectRatio="xMidYMid meet"
      style={{
        position: 'absolute',
        inset: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
      }}
      aria-label="Drill working area"
    >
      <rect
        x={rect.cx} y={rect.cy} width={rect.w} height={rect.h}
        fill="none"
        stroke="#27AE60"
        strokeWidth={SW}
        strokeDasharray={`${SW * 4} ${SW * 3.5}`}
      />
    </svg>
  );
}
